// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"ca2afe58","513":"a8a1b773","787":"4a74016e"}[chunkId] + ".chunk.js";
};